<template lang="pug">
    .inner-content(v-if="$is('listing')")
      .row
        .column
          .field
            router-link(:to="{name:'coupons'}") C{{item.id}}
          .field Code:{{ item.coupon.code}}
        .column
          .field
            router-link(:to="{name:'driver', params:{id:item.driver.id}}" ) D{{ item.driver.id }}
          .field {{item.driver.client_name}}
        .column
          .field Created
          .field {{item.created}}
        .column(v-if="item.coupon.common_cost !== null")
          .field {{item.coupon.common_cost.reason}}
          .field {{$priceWithcurrency($priceWithVat(item.coupon.common_cost.amount, item.coupon.common_cost.tax).toFixed(2))}}
        .column(v-else)
          .field Discount
            .field {{item.coupon.discount_rate}}%
        .column
          .field Valid from
          .field {{item.coupon.start}}
          .field Valid to
          .field {{item.coupon.end}}
</template>

<script>

  export default {
    name: 'CouponInUse',
    components: {},
    props: ['item', 'type']

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CouponInUse.vue?6c02609c